
import { defineComponent } from "vue";
import { Banner, Item } from "@/types";
import { ItemDatabase } from "@/state/Gacha";

export default defineComponent({
  props: {
    banner: {
      type: Object as () => Banner,
      required: true,
    },
    rarity: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      table: (() => {
        const drops: Item[][] = [[], [], [], [], [], []];
        for (const i of this.banner.featuredDrops) {
          const item = ItemDatabase[i];
          drops[item.rarity].push({ featured: true, ...item });
        }
        for (const i of this.banner.drops) {
          if (
            ((i: Item) => {
              for (const it of drops[i.rarity]) {
                if (it.id === i.id) {
                  return false;
                }
              }
              return true;
            })(ItemDatabase[i])
          ) {
            // aiya ram go boom
            drops[ItemDatabase[i].rarity].push(ItemDatabase[i]);
          }
        }
        return drops;
      })(),
    };
  },
});
